exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-eye-pro-sistema-pdv-restaurantes-e-alimentacao-js": () => import("./../../../src/pages/eye-pro-sistema-pdv-restaurantes-e-alimentacao.js" /* webpackChunkName: "component---src-pages-eye-pro-sistema-pdv-restaurantes-e-alimentacao-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

